<template>
  <f7-page name="price">
    <f7-navbar title="Прайс-лист" back-link-force back-link-url="/" back-link></f7-navbar>
    <div id="serviceData">
      <f7-block-title>Автомобиль</f7-block-title>
      <f7-list no-hairlines-md>
        <f7-list-input name="car" v-model="$root.selectCar" :value="$root.selectCar"
          @input="$root.selectCar = $event.target.value" type="select" error-message="Выберите автомобиль"
          @focus="errorBodyType = false" :error-message-force="errorBodyType" placeholder="Выберите автомобиль...">
          <option v-for="(car, index) in $root.garage.data" :key="index" :value="index">
            {{ car.attributes.carBrand }} {{ car.attributes.stateNumber }}
          </option>
          <option value="add">добавить/редактировать</option>
        </f7-list-input>
      </f7-list>
      <template v-if="!$root.isServices">
        <f7-block-title>Гараж</f7-block-title>

        <f7-list>
          <f7-list-item v-for="(car, index) in $root.garage.data" :key="index" :title="car.attributes.carBrand" link="#"
            @click="$root.createPopup(car.id)">
            <f7-icon slot="media" f7="car_fill"></f7-icon>
          </f7-list-item>

          <f7-list-item title="Добавить автомобиль" @click="$root.createPopup" link="#">
            <f7-icon slot="media" f7="plus_circle"></f7-icon>
          </f7-list-item>
        </f7-list>
      </template>
      <f7-block-title v-show="$root.isServices">Услуги</f7-block-title>
      <f7-col v-show="$root.preloader" class="text-align-center">
        <f7-preloader></f7-preloader>
      </f7-col>
      <f7-list v-show="$root.isServices" media-list>
        <f7-list-item v-for="(service, index) in $root.services.data" :key="index" checkbox name="services"
          :value="service.id" :title="service.attributes.title" v-bind:after="price(service.attributes.price)"
          v-bind:text="service.attributes.body">
          <div slot="after-start">
            <span class="text-color-gray" style="margin-right: 6px; font-size: smaller; white-space: nowrap">{{
                service.attributes.duration
            }} мин.</span>
          </div>
        </f7-list-item>
      </f7-list>
      <f7-block>
        <p>
          &nbsp;
        </p>
      </f7-block>
    </div>
    <f7-fab v-show="$root.isServices" @click="checkForm" position="center-bottom" slot="fixed" text="Далее"
      color="black">
      <f7-icon ios="f7:chevron_right" aurora="f7:chevron_right" md="material:chevron_right"></f7-icon>
    </f7-fab>

    <!-- <f7-block v-show="$root.isServices">
      <f7-row tag="p">
        <f7-button class="col" @click="checkForm" raised fill>Далее</f7-button>
        <f7-button class="col" href="/" raised>Отмена</f7-button>
      </f7-row>
    </f7-block> -->
  </f7-page>
</template>
<script>
export default {
  data() {
    // console.log(form.car);
    return {
      errorBodyType: false,
    };
  },
  watch: {
    "$root.selectCar": function () {
      // console.log("sdasdasd");
      this.checkForm(false);
    },
  },
  methods: {
    price(price) {
      return parseInt(price).toLocaleString("ru-RU") + ` ₽`;
    },
    checkForm(check = true) {
      var formData = this.$f7.form.convertToData("#serviceData");
      console.log("formData");
      console.log(formData);
      if (this.$root.selectCar == "add" || formData.car == "add") {
        if (this.$root.selectCar != "add") {
          formData.car = 0;
          this.$root.isServices = true;
        } else {
          this.$root.isServices = false;
          return false;
        }
      } else {
        this.$root.isServices = true;
        // return false;
      }
      if (formData == undefined || formData.car == "") {
        formData.car = 0;
        formData.services = [];
        this.form = 0;
      }
      var order = {
        car: this.$root.garage.data[formData.car],
        services: formData.services,
      };
      console.log("order");
      console.log(order);
      this.$root.category =
        this.$root.garage.data[formData.car].attributes.category;
      this.writeStorage(order);
      this.$root.getServices();
      if (
        Array.isArray(formData.services) &&
        formData.services.length == 0 &&
        check
      ) {
        this.$f7.dialog.alert(
          "Выберите услугу, которой желаете воспользоваться.",
          "Ошибка"
        );
        return false;
      }
      if (check) {
        console.log("Подтверждение записи.");
        this.$f7.views.main.router.navigate("/confirm/");
      }
    },
    writeStorage(formData) {
      localStorage.setItem("order", JSON.stringify(formData));
    },
  },
  mounted: function () {
    this.$root.cars("", "GET", "cars", ["service", "garage", "popup"]);
  },
};
</script>
